import React from 'react';
import './GraphicalIcon.css';
import logComponent from '../../common/logComponent';

export default function GraphicalIcon({ url, alt, svg }) {
  if (logComponent('GraphicalIcon')) { console.debug('GraphicalIcon render'); }
  const svgFromString = new Blob([svg], { type: "image/svg+xml" });
  const urlFromSvgString = URL.createObjectURL(svgFromString);
    return (
      <span className="Graphical-Icon">
        {svg &&
          <img src={urlFromSvgString} />
        }
        {url &&  
          <img
            src={url}
            alt={alt}
            />
        }
      </span>
    );
}